'use client';

import * as React from 'react';
import * as SwitchPrimitive from '@radix-ui/react-switch';

import { cn } from '@/lib/utils';
import { SvgCheckmark } from '@/components/icons-eataly';

const Switch = React.forwardRef<
    React.ComponentRef<typeof SwitchPrimitive.Root>,
    React.ComponentPropsWithoutRef<typeof SwitchPrimitive.Root>
>(({ className, ...props }, ref) => (
    <SwitchPrimitive.Root
        data-slot="switch"
        className={cn(
            'peer inline-flex h-6 w-14 shrink-0 cursor-pointer items-center p-1 rounded-full shadow-xs transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input',
            className
        )}
        {...props}
        ref={ref}>
        <SwitchPrimitive.Thumb
            data-slot="switch-thumb"
            className={cn(
                'group pointer-events-none inline-flex items-center justify-center h-4 w-4 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-8 data-[state=unchecked]:translate-x-0'
            )}
        >
            <SvgCheckmark aria-hidden className='opacity-0 transition-opacity duration-200 group-data-[state=checked]:opacity-100 size-4' />
        </SwitchPrimitive.Thumb>
    </SwitchPrimitive.Root>
));
Switch.displayName = SwitchPrimitive.Root.displayName;

export { Switch };